import { useCallback, useEffect } from 'react';
import { CACHE_TTL, isCacheValid } from '@/utils/cache';
import { useRegieStore } from '@/zustand';
import useCyclesStore from '@/zustand/accueil/useCyclesStore';

/**
 * Hook pour récupérer les cycles avec cache automatique
 * Vérifie le cache à chaque utilisation et fetch si nécessaire
 */
const useCyclesData = () => {
  const regie = useRegieStore((state) => state.regie);
  const regieId = regie?.identifiant;
  const periodicite = regie?.periodiciteArrete || 'Mensuel';
  const regieProlongee = regie?.regieProlongee || false;
  const joursSupplementaires = regie?.joursEncaissementSupplementaires || 0;

  const cycles = useCyclesStore((state) => state.data);
  const loading = useCyclesStore((state) => state.loading);
  const error = useCyclesStore((state) => state.error);
  const cache = useCyclesStore((state) => state.cache);
  const fetch = useCyclesStore((state) => state.fetch);

  // Vérification du cache à chaque utilisation du hook
  useEffect(() => {
    if (regieId && !isCacheValid(cache.timestamp, CACHE_TTL.CYCLES, cache.regieId, regieId)) {
      fetch(regieId, periodicite, regieProlongee, joursSupplementaires);
    }
  }, [
    regieId,
    periodicite,
    cache.timestamp,
    cache.regieId,
    regieProlongee,
    joursSupplementaires,
    fetch,
  ]);

  // Fonction pour forcer un refresh manuel
  const refresh = useCallback(() => {
    if (regieId) {
      fetch(regieId, periodicite, regieProlongee, joursSupplementaires, true);
    }
  }, [regieId, periodicite, regieProlongee, joursSupplementaires, fetch]);

  return {
    cycles,
    loading,
    error,
    refresh,
  };
};

export default useCyclesData;
